module.exports = __webpack_public_path__ + "img/value2.ad0adc13.png";